<template>
  <div class="border mt-3">
    <h4>Коробки</h4>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setImport="false"
      :setLink="setLink"
      :staticFilters="staticFilters"
      :openItem="true"
      :fields="fields"
      :filters="filters"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :dateFilter="dateFilter"
    />
  </div>
</template>
<script>
export default {
  watch: {},
  props: ["id"],
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  created() {
    this.itemLink = `transfers/${this.id}/transfer_containers`;
    this.setLink = `transfers/${this.id}/transfer_containers`;
  },
  data() {
    return {
      filters: [],
      staticFilters: [],
      params: {},
      val: [],
      modalCreate: "role",
      fields: [
        {
          label: "Вес (кг) - мин 1 кг",
          key: "weight",
          type: "field",
          textType: "number",
          default: "1",
        },
        {
          label: "Ширина (см)",
          key: "width",
          type: "field",
          textType: "number",
          default: "30",
        },
        {
          label: "Высота (см)",
          key: "height",
          type: "field",
          textType: "number",
          default: "20",
        },
        {
          label: "Длинна (см)",
          key: "length",
          type: "field",
          textType: "number",
          default: "25",
        },
      ],
      dateFilter: [
        // {
        //   key: "from_at",
        //   titleKey: "from_at",
        //   title: "Начало даты",
        // },
        // {
        //   key: "till_at",
        //   titleKey: "till_at",
        //   title: "Конец даты",
        // },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_transfer_container",
      itemLink: "transfers",
      setLink: "transfers",
      columns: [
        {
          detail: true,
        },
        {
          key: "weight",
          title: "Вес (кг)",
        },
        {
          key: "width",
          title: "Ширина (см)",
        },
        {
          key: "height",
          title: "Высота (см)",
        },
        {
          key: "length",
          title: "Длинна (см)",
        },
        {
          remove: true,
        },
      ],
    };
  },
};
</script>